/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown>, field: NonNullable<unknown> }} Warning_Invalid_ValueInputs */

const en_warning_invalid_value = /** @type {(inputs: Warning_Invalid_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} is not valid for ${i?.field}`)
};

const de_warning_invalid_value = /** @type {(inputs: Warning_Invalid_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} ist für ${i?.field} nicht gültig`)
};

/**
* | output |
* | --- |
* | "{value} is not valid for {field}" |
*
* @param {Warning_Invalid_ValueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warning_invalid_value = /** @type {((inputs: Warning_Invalid_ValueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warning_Invalid_ValueInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_warning_invalid_value(inputs)
	return en_warning_invalid_value(inputs)
});